const DEC_TYPE = 2;

let baseServerUrl = "";

switch(DEC_TYPE){
  case 0:
    // baseServerUrl = "http://192.168.199.121:7360/api/service/monitor/v1";
    baseServerUrl = "http://192.168.1.115:7360/api/service/monitor/v1";
    break;
  case 1:
    baseServerUrl = "http://192.168.1.18:7080/api/service/monitor/v1";
    break;
  case 2:
    let ipport = location.href.split('/');
    let svrhost = ipport[0]+"//"+ipport[2];
    baseServerUrl = svrhost + "/api/service/monitor/v1"
    break;
  case 3:
    baseServerUrl = "http://ar.operation.teameeting.cn/api/service/monitor/v1"
    break;
}

export default {
  baseServerUrl,
}



// WEBPACK FOOTER //
// ./src/config/index.js